// Накопленный список товаров для сравнения — общий для кнопок на карточке
// товара (compare_bar_controller.js), конструктора (compare_picker_controller.js)
// и крестика на странице результата (compare_remove_controller.js).
//
// Записи — { slug, type }, где type — product_type_id: ракетку с кроссовком
// не сравнивают, и каждый экран берёт из общего списка только товары своего
// типа. Строки старого формата (голые slug'и, без типа) отбрасываем: к
// какому набору они относятся, уже не узнать.
const STORAGE_KEY = 'padelmesh:compare-slugs'

export { STORAGE_KEY }

export function readCompareList() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) return []

    return parsed.filter(
      (entry) =>
        entry && typeof entry.slug === 'string' && Number.isInteger(entry.type)
    )
  } catch {
    return []
  }
}

export function writeCompareList(list) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list))
  } catch {
    // Приватный режим браузера и подобное — список просто не переживёт
    // переход на другую страницу, ничего не ломаем попыткой записи.
  }
}

export function removeFromCompareList(slug) {
  const list = readCompareList()
  const next = list.filter((entry) => entry.slug !== slug)
  if (next.length !== list.length) writeCompareList(next)
}
